var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4 px-6",attrs:{"flat":""}},[(_vm.queue.text)?_c('v-row',{staticClass:"pt-4",attrs:{"no-gutters":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.queue.text)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }